import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "shareModal.title",
    },
    share: {
        id: "shareModal.share",
    },
    link: {
        id: "shareModal.link",
    },
    social: {
        id: "shareModal.social",
    },
    facebook: {
        id: "shareModal.social.facebook",
    },
    noCopy: {
        id: "shareModal.noCopy",
    },
});

export default messages;
